module.exports = __webpack_public_path__ + "assets/images/EUR050.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR050.png
// module id = 1361
// module chunks = 1